import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import ArrowRightIcon from '@mui/icons-material/ArrowForward';
import Image from 'components/Image';
import { useState } from 'react';
import shadow from '../../helpers/shadow';
import Link from '@mui/material/Link';
import LoginButton from '../Header/LoginButton';

export default function CarouselCardItem({ post }) {
  const [open, setOpen] = useState(false);

  const useStyles = makeStyles()(() => ({
    imgContainer: {
      height: '220px',
      width: '100%',
      overflow: 'hidden',
      position: 'relative',
    },
    heading: {
      fontSize: 20,
      lineHeight: 1.3,
    },
    card: {
      height: 290,
      borderRadius: 8,
      boxShadow: shadow.md,
    },
  }));

  const { classes } = useStyles();

  const card = (
    <Card className={classes.card}>
      <CardActionArea>
        <div className={classes.imgContainer}>
          <div
            style={{ backgroundColor: post.bgColor, height: 220 }}
            className="d-flex p-1"
          >
            <Image
              alt={`${post.heading} ${post.subheading}`}
              className="align-self-center"
              src={post.image.src}
              width={post.image.width}
              height={post.image.height}
            />
          </div>
        </div>
        <div className="row" style={{ height: 80 }}>
          <div className="col-9 p-2 pl-4" style={{ height: 80 }}>
            <Typography
              color="textPrimary"
              variant="h6"
              component="h2"
              className={`${classes.heading} textPrimary font-weight-bold`}
            >
              {post.heading}
              <br />
              {post.subheading}
            </Typography>
          </div>
          <div className="col-3 my-auto">
            <ArrowRightIcon />
          </div>
        </div>
      </CardActionArea>
    </Card>
  );

  if (post.isJoinPopup)
    return (
      <>
        <div
          className="w-100 border-0"
          onClick={() => setOpen(true)}
          onKeyPress={() => setOpen(true)}
          role="button"
          tabIndex={0}
        >
          {card}
        </div>
        {open && (
          <LoginButton
            open={open}
            hideButtons
            onClickClose={() => setOpen(false)}
            text=" and start a travel blog"
          />
        )}
      </>
    );
  return (
    <div className="w-100">
      <Link color="textPrimary" href={post.permlink}>
        {card}
      </Link>
    </div>
  );
}
